import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "favorite-box",
  class: "center dark-scrub-backgound"
}
const _hoisted_2 = {
  href: "https://yjmthu.github.io/vua/vua.crx",
  target: "_blank"
}
const _hoisted_3 = {
  key: 0,
  id: "favorite-bookmarks"
}
const _hoisted_4 = ["onClick", "onContextmenu"]
const _hoisted_5 = {
  key: 1,
  id: "all-bookmarks"
}
const _hoisted_6 = ["onClick", "onContextmenu"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createElementVNode("div", null, [
        _createElementVNode("small", {
          onClick: _cache[0] || (_cache[0] = () => {_ctx.currentTab = 0}),
          class: _normalizeClass({active: _ctx.currentTab === 0})
        }, "收藏", 2),
        (_ctx.isChromeExt)
          ? (_openBlock(), _createElementBlock("small", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = () => {_ctx.currentTab = 1}),
              class: _normalizeClass({active: _ctx.currentTab === 1})
            }, "书签", 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_SvgIcon, {
          name: "ArrowLeft",
          size: "30px",
          onClick: _ctx.leaveNode
        }, null, 8, ["onClick"]),
        _createVNode(_component_SvgIcon, {
          name: "ViewfinderCircle",
          size: "30px",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({path: 'scan'})))
        }),
        _createElementVNode("a", _hoisted_2, [
          _createVNode(_component_SvgIcon, {
            name: "Extension",
            size: "30px"
          })
        ]),
        _createVNode(_component_SvgIcon, {
          name: "ArrowUpCircle",
          size: "30px",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uploadBookmarks()))
        }),
        _createVNode(_component_SvgIcon, {
          name: "ArrowDownCircle",
          size: "30px",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadBookmarks()))
        }),
        _createVNode(_component_SvgIcon, {
          name: "Trash",
          size: "30px",
          class: _normalizeClass({ checked: _ctx.isTrashMode }),
          onClick: _ctx.switchTrashMode
        }, null, 8, ["class", "onClick"])
      ])
    ]),
    (_ctx.vifFavoritesTab)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favoriteBookmark, (data, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (_ctx.clickFavorite(index)),
              onContextmenu: _withModifiers(($event: any) => (_ctx.editFavorite(index)), ["prevent"])
            }, _toDisplayString(data.name), 41, _hoisted_4))
          }), 128)),
          _createElementVNode("li", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editFavorite(_ctx.favoriteBookmark.length)))
          }, [
            _createVNode(_component_SvgIcon, {
              name: "PlusSmall",
              size: "24px"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.vifBookmarksTab)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentNode?.children, (data, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (_ctx.enterNode(index)),
              onContextmenu: _withModifiers(($event: any) => (_ctx.editBookmark(index)), ["prevent"])
            }, [
              _createVNode(_component_SvgIcon, {
                name: data.children ? 'Folder': 'Document',
                size: "14px"
              }, null, 8, ["name"]),
              _createElementVNode("span", null, _toDisplayString(data.title), 1)
            ], 40, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('toggleVisbility')))
    }, _toDisplayString(_ctx.getCurrentParth()), 1)
  ]))
}